import { render } from "./IClassroomMultiPicker.vue?vue&type=template&id=38ef5e66"
import script from "./IClassroomMultiPicker.vue?vue&type=script&lang=js"
export * from "./IClassroomMultiPicker.vue?vue&type=script&lang=js"

import "./IClassroomMultiPicker.vue?vue&type=style&index=0&id=38ef5e66&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__